// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {LeadsState} from 'redux/uiState/lead/leadsState';

import {
  createReducerUsingActionHandlers,
  PURE,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {LEAD_SECTION_CONSENT} from 'consts';
import {SET_LEADS_STATE} from 'redux/uiState/lead/actions';
import {leadsState} from 'redux/uiState/UiState';

const initState: LeadsState = {
  confirmed: 0,
};

const actionCreators: ActionHandlers<LeadsState> = {
  [PURE(SET_LEADS_STATE)]: (state: LeadsState, {id}) => {
    const storageData = JSON.parse(
      localStorage.getItem(LEAD_SECTION_CONSENT) || '{"confirmed":[]}'
    )
    storageData.confirmed.push(id);
    localStorage.setItem(
      LEAD_SECTION_CONSENT,
      JSON.stringify(storageData)
    );
    return {
      ...state,
      confirmed: id,
    };
  },
};

export const leadsReducer: Reducer<LeadsState> =
  createReducerUsingActionHandlers<LeadsState>(initState, actionCreators);

export const getLeadsConfirmed: Selector<number> = createSelector(
  leadsState,
  (state: LeadsState) => JSON.parse(
    localStorage.getItem(LEAD_SECTION_CONSENT) || '{"confirmed": []}'
  ).confirmed
);
